import { useSelector } from 'react-redux';

import { businessAppointmentsSelector } from 'shared/store/data/filters/selectors/dump/businessAppointmentsSelector';

export function useBusinessAppointmentsSelector(): Array<number> {
  return useSelector(businessAppointmentsSelector);
}
